import client from './client';

export async function listExcelTemplates() {
  const { data } = await client.get('/excel-templates');
  return data.data;
}

export async function createExcelTemplate(payload) {
  const { data } = await client.post('/excel-templates', payload);
  return data.data;
}

export async function updateExcelTemplate(id, payload) {
  const { data } = await client.put(`/excel-templates/${id}`, payload);
  return data.data;
}

export async function deleteExcelTemplate(id) {
  await client.delete(`/excel-templates/${id}`);
}

export function exportBulkRequests(ids, excelTemplateId) {
  return client.get('/bulk-requests/export', { params: { ids, excel_template_id: excelTemplateId }, responseType: 'blob' });
}

export function exportCandidateRequests(type, ids, excelTemplateId) {
  return client.get(`/${type}-requests/export`, { params: { ids, excel_template_id: excelTemplateId }, responseType: 'blob' });
}
